<div class="utm-wrapper">
  <div class="utm-content">
    <app-close-btn top="8px" right="8px"(click)="paymentUtilService.utmProceedClicked = false"></app-close-btn>
    <div class="hundred-rs-img">
      <img loading="lazy" data-src="/assets/images/rs-100-utm.png" alt="utm 100rs" />
    </div>
    <div class="offer-title">
      Limited Offer!
    </div>
    <div class="offer-desc">
      <strong>₹100</strong>
      will be added to {{data.name}}’s recovery fund once you complete your contribution.
    </div>
    <div class="line"></div>
    <div class="action-btn">
      <app-button label="Apply" btnClass="primary-btn utmProceedBtn" (click)="activateHundredRs()"></app-button>
    </div>
  </div>
</div>
